import Vue from 'vue'

import SearchForm from './components/SearchForm/SearchForm.vue'
import StoreLocator from './components/StoreLocator.vue'

const {
  __,
  _x,
  _nx,
  sprintf,
} = wp.i18n

export default (() => {
  Vue.component('search-form', SearchForm);
  Vue.component('store-locator', StoreLocator);

  // Add WP translations function to vue
  Vue.mixin({
    methods: {
        __,
        _x,
        _nx,
        sprintf,
    },
  });

  new Vue({
    el: '.page-template-store-locator #app, .header-wrapper',
    data: {},
  })
})();


// WEBPACK FOOTER //
// ./scripts/vueApp.js